import React from 'react';
import { Close } from '@mui/icons-material';

export const Modal = ({ children, isOpen, handleClose, title }) => {
  if (!isOpen) return null;

  return (
    <div className='modal-backdrop' onClick={handleClose}>
      <div
        className='modal-container'
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {title && (
          <div className='modal-title-container'>
            <p className='modal-title'>{title}</p>
        </div>
        )}
        <div onClick={handleClose} className='close-modal-button'>
          <Close fontSize='medium' />
        </div>
        <div className='modal-container-inner'>{children}</div>
      </div>
    </div>
  );
};
